import React, { useRef } from "react";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { Dialog, DialogTitle } from "@mui/material";

function PaperComponent({ nodeRef, ...props }) {
    return (
        <Draggable
            nodeRef={nodeRef}
            handle={`#${props["data-handle-id"]}`}
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
}

const DraggableHelpDialog = ({
    dgKey = "draggable-dialog-title",
    open,
    onClose,
    children,
    ...rest
}) => {
    const paperRef = useRef(null);

    // Inject props into the DialogTitle child automatically
    const enhancedChildren = React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;

        if (child.type === DialogTitle) {
            return React.cloneElement(child, {
                id: dgKey,
                style: { ...(child.props.style || {}), cursor: "move" },
            });
        }

        return child;
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperComponent={(p) => (
                <PaperComponent
                    {...p}
                    data-handle-id={dgKey}
                    nodeRef={paperRef}
                />
            )}
            aria-labelledby={dgKey}
            {...rest}
        >
            {enhancedChildren}
        </Dialog>
    );
};

export default DraggableHelpDialog;
